module.exports = __webpack_public_path__ + "img/studyOnlyWithIvyed.a3df13a5.png";